import { JDSBottomFooterProps } from './generated';

export const withLogic =
  (
    Component: React.ComponentType<JDSBottomFooterProps>
  ): React.FC<JDSBottomFooterProps> =>
  (props: JDSBottomFooterProps) => {
    const length = props.informationalLinks?.length;

    const informationalLinks = props.informationalLinks?.map(
      (item: any, i: number) => ({
        ...item,
        separator: i !== length - 1
      })
    );

    return (
      <Component
        {...props}
        _hasLink={Boolean(props.copyright?.href)}
        informationalLinks={informationalLinks}
      />
    );
  };
